export default "__VITE_ASSET__DPYs0kpU__"